import { useEffect, useState } from "react";

import CompetitionRounds from "./CompetitionRounds";
import ErrorBoundaryComponent from "@components/core/modules/ErrorBoundaryComponent";
import Spinner from "@components/core/atoms/Spinner";
import FootballAPI from "@api/football.api";
import styles from "./styles";
import useNavigationParams from "@hooks/useNavigationParams";
import FixturesScore from "./FixturesScore";
import useLiveFixturesRefresh from "@hooks/useLiveFixturesRefresh"; // import the hook

import SUPPORTED_COMPETITIONS from "@utils/SUPPORTED_COMPETITIONS";

const FixturesByRoundWidget = () => {
  const [rounds, setRounds] = useState(null);
  const [currentRound, setCurrentRound] = useState({});
  const [isLoadingData, setLoadingData] = useState(false);

  const { searchParams } = useNavigationParams();

  const leagueId =
    SUPPORTED_COMPETITIONS[searchParams.competition?.toLowerCase().trim()];

  // fetch fixtures and rounds initially
  const fetchFixturesAndRounds = async (competitionId) => {
    setLoadingData(true);
    const result = await FootballAPI.getFixturesAndRounds(competitionId);

    setRounds(result.rounds.rounds);
    setCurrentRound(result.rounds.current);
    setFixtures(result.fixtures); // initial fixtures for the hook
    setLoadingData(false);
  };

  // use our live-refresh hook
  const [fixtures, setFixtures] = useLiveFixturesRefresh(
    leagueId,
    [], // will be populated after first fetch
    currentRound.id
  );

  // manual fetch for round change
  const fetchFixtures = async (competitionId, round) => {
    setLoadingData(true);
    const result = await FootballAPI.getFixtures(competitionId, null, round);

    setFixtures(result); // update fixtures for hook
    setLoadingData(false);
  };

  const onChangeRound = (strRound) => {
    const newRound = JSON.parse(strRound);
    setCurrentRound(newRound);

    if (newRound.id !== currentRound.id) {
      fetchFixtures(leagueId, newRound.id);
    }
  };

  // initial fetch on mount
  useEffect(() => {
    fetchFixturesAndRounds(leagueId);
  }, []);

  return (
    <ErrorBoundaryComponent>
      <div style={{ width: "100%", paddingTop: 40 }}>
        {!isLoadingData && rounds ? (
          <div style={styles.stageSelectionContainer}>
            <CompetitionRounds
              rounds={rounds}
              current={currentRound}
              onChangeRound={onChangeRound}
            />
          </div>
        ) : null}

        {!isLoadingData && fixtures ? (
          <FixturesScore fixtures={fixtures} />
        ) : null}

        {isLoadingData ? (
          <div style={styles.spinner.container}>
            <Spinner />
          </div>
        ) : null}
      </div>
    </ErrorBoundaryComponent>
  );
};

export default FixturesByRoundWidget;
